export default [
  /IDLE_(.*)/,
  /@@redux-form(.*)/,
  /@ReduxToastr(.*)/
];


// WEBPACK FOOTER //
// ./src/constants/redux-logger-exclusions.js